import { Link } from "react-router";
import { Button } from "@/components/ui/button";

export function AuthErrorPage() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-semibold text-foreground">
        No se pudo abrir esta pantalla
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Tu cuenta y los datos de NAIU siguen guardados. Vuelve al inicio para
        seguir trabajando.
      </p>
      <Button asChild>
        <Link to="/">Volver al inicio</Link>
      </Button>
    </div>
  );
}
